// @ts-ignore
import * as ramda from 'ramda';

export const stripTypename = ramda.omit(['__typename']);
